// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","403":"2bdc15da","455":"23a7dc10","484":"14cb0921","629":"3c99ad5f","869":"b6dda42b","974":"87dcfbc9","977":"5d9c67ca"}[chunkId] + ".chunk.js";
};